import { render, staticRenderFns } from "./projectDeveloper.vue?vue&type=template&id=54bdfac6&"
import script from "./projectDeveloper.vue?vue&type=script&lang=js&"
export * from "./projectDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./projectDeveloper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports